import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor() { }

  hexToHSL(H:string):{h:number, s:number, l:number} {
    // Convert hex to RGB first
    let r:any = 0, g:any = 0, b:any = 0;
    if (H.length == 4) {
      r = "0x" + H[1] + H[1];
      g = "0x" + H[2] + H[2];
      b = "0x" + H[3] + H[3];
    } else if (H.length == 7) {
      r = "0x" + H[1] + H[2];
      g = "0x" + H[3] + H[4];
      b = "0x" + H[5] + H[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    let cmin = Math.min(r,g,b),
        cmax = Math.max(r,g,b),
        delta = cmax - cmin,
        h = 0,
        s = 0,
        l = 0;

    if (delta == 0)
      h = 0;
    else if (cmax == r)
      h = ((g - b) / delta) % 6;
    else if (cmax == g)
      h = (b - r) / delta + 2;
    else
      h = (r - g) / delta + 4;

    h = Math.round(h * 60);

    if (h < 0)
      h += 360;

    l = (cmax + cmin) / 2;
    s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);

    return { h: h, s: s, l: l };
  }

  hexToHSLString(H:string) {
    const hsl = this.hexToHSL(H);
    return this.hslToString(hsl);
  }

  hslToString(hsl:{h:number, s:number, l:number}) {
    return "hsl(" + hsl.h + "," + hsl.s + "%," + hsl.l + "%)";
  }

  hexToRGB(h:string): {r:number, g:number, b:number} {
    let r:any = 0, g:any = 0, b:any = 0;

    // 3 digits
    if (h.length == 4) {
      r = "0x" + h[1] + h[1];
      g = "0x" + h[2] + h[2];
      b = "0x" + h[3] + h[3];

    // 6 digits
    } else if (h.length == 7) {
      r = "0x" + h[1] + h[2];
      g = "0x" + h[3] + h[4];
      b = "0x" + h[5] + h[6];
    }

    return { r: r, g: g, b: b };
  }

  rgbToString(rgb:{r:number, g:number, b:number}) {
    return "rgb("+ rgb.r + "," + rgb.g + "," + rgb.b + ")";
  }

  hexToRGBString(h:string) {
    const rgb = this.hexToRGB(h);
    return this.rgbToString(rgb);
  }

  lighterColor(hex:string) {
    let hsl = this.hexToHSL(hex);
    hsl.l = 90;
    return this.hslToString(hsl);
  }

  darkerColor(hex:string) {
    let hsl = this.hexToHSL(hex);
    hsl.l = Math.max(hsl.l - 10, 10);
    return this.hslToString(hsl);
  }

  b64toBlob(dataURI:string, type:string = 'image/jpeg'): Blob {
    var byteString = atob(dataURI.split(',')[1]);
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);

    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: type });
  }

  delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) );
  }

}
